/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import {
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import ShowIf from 'loracoms/ShowIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';


const propTypes = {
  band: React.PropTypes.string.isRequired,
  onSelect: React.PropTypes.func.isRequired,
  onUnselect: React.PropTypes.func.isRequired,
  selected: React.PropTypes.array.isRequired,
  channels: React.PropTypes.array.isRequired,
  maxSelected: React.PropTypes.number.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class FixedChannels extends React.Component {

  constructor(props) {
    super(props);
    this.band = props.band;
    this.state = {
      band: props.band,
      channels: props.channels,
      selected: props.selected,
    };
    this.handleClick = this.handleClick.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'network.channelview.add.fixed');
  }

  componentWillReceiveProps(nextProps) {
    const { band, selected, channels } = nextProps;
    if (band !== this.props.band) {
      this.band = band;
      this.setState({ band });
    }
    if (selected !== this.props.selected) {
      this.setState({ selected });
    }
    if (channels !== this.props.channels) {
      this.setState({ channels });
    }
  }

  handleClick(channel) {
    const { onSelect, onUnselect, maxSelected } = this.props;
    const { selected = [] } = this.state;
    const index = selected.findIndex(ch => ch.id === channel.id);
    if (index >= 0) {
      onUnselect(channel);
    } else if (selected.length < maxSelected) {
      onSelect(channel);
    }
  }

  render() {
    const { maxSelected } = this.props;
    const {
      band = '',
      channels = [],
      selected = [],
    } = this.state;

    const detail = channel => (
      <Tooltip id="tooltip">
        <div className={styles.detail}>
          <div className={styles.label}>Frequence</div>
          <div className={styles.value}>{`${channel.freq / 1000000}MHZ`}</div>
        </div>
        <div className={styles.detail}>
          <div className={styles.label}>Min DR</div>
          <div className={styles.value}>{channel.mindr}</div>
        </div>
        <div className={styles.detail}>
          <div className={styles.label}>Max DR</div>
          <div className={styles.value}>{channel.maxdr}</div>
        </div>
      </Tooltip>
    );
    return (
      <div className={styles.container}>
        <div className={styles.notes}>
          <ul className={styles.legends}>
            <li>
              <span className={`${styles.icon} ${styles.available}`} />
              <span className={styles.label}>{this.intlMsg.msg('available')}</span>
            </li>
            <ShowIf if={band === 'CN470'}>
              <li>
                <span className={`${styles.icon} ${styles.restrict}`} />
                <span className={styles.label}>{this.intlMsg.msg('restrict')}</span>
                <span className={styles.ref}><i className="fa fa-asterisk" /></span>
              </li>
            </ShowIf>
            <li>
              <span className={`${styles.icon} ${styles.selected}`} />
              <ShowIf if={band === 'CN470'}>
                <span className={`${styles.icon} ${styles.selectedAlt}`} />
              </ShowIf>
              <span className={styles.label}>{this.intlMsg.msg('selected')}</span>
            </li>
            <li>
              <span className={`${styles.icon} ${styles.full}`} />
              <span className={styles.label}>{this.intlMsg.msg('full')}</span>
            </li>
          </ul>
          <ShowIf if={band === 'CN470'}>
            <div className={styles.caution}>
              <i className="fa fa-asterisk" />{' '}{this.intlMsg.msg('restrict.caution')}
            </div>
          </ShowIf>
        </div>

        <ul className={styles.channels}>
          {channels.map((channel) => {
            const selIndex = selected.findIndex(ch => ch.id === channel.id);
            const restrict = (
              band === 'CN470' &&
              (_.inRange(channel.id, 6, 39) || _.inRange(channel.id, 45, 78)));
            return (
              <li
                key={channel.id}
                className={`
                  ${styles.box}
                  ${selIndex >= 0 ? styles.selected : ''}
                  ${selected.length >= maxSelected ? styles.full : ''}
                  ${restrict ? styles.restrict : ''}
                `.replace(/\n/g, ' ')}
              >
                <ShowIf if={selIndex >= 0}>
                  <div className={styles.idx}>
                    {selIndex + 1}
                  </div>
                </ShowIf>
                <OverlayTrigger placement="top" overlay={detail(channel)}>
                  <Link onClick={() => this.handleClick(channel)}>
                    <div className={styles.freq}>
                      {channel.freq / 1000000}
                    </div>
                    <div className={styles.id}>
                      {channel.id}
                    </div>
                  </Link>
                </OverlayTrigger>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

FixedChannels.propTypes = propTypes;

export default injectIntl(FixedChannels);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/FixedChannels/index.jsx